import { AppParentContext } from 'global/cnr/contexts/AppParentContext';
import { useContext, useEffect, useState } from 'react';
import { ActionContext } from '../../cnr/contexts/ActionContext';
import { AppUserManagerContext } from '../../cnr/contexts/AppUserManagerContext';
import { PapsContext } from '../../cnr/contexts/PapsContext';
import { appFormTypes } from '../../enums/appFormTypes';
import MotionWait from '../../motions/MotionWait';
import FullPageWrapper from '../../wrappers/FullPageWrapper';
import NoData from '../alerts/NoData';
import AppForm from '../forms/appForms/AppForm';
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper';

export const _authProjectName = null // 'pojo-1fdf3'

/** Returns a user's authhentication
 * @param itemData
 */
const UserAuth = ({ handleCancel }) => {

  const appParentContext = useContext(AppParentContext);
  const { fn_cls } = appParentContext ?? {}

  // papsContext
  const papsContext = useContext(PapsContext);
  const { paps_state } = papsContext ?? {}
  const { pathViews } = paps_state ?? {}

  // appFormsContext
  const actionContent = useContext(ActionContext);
  const { action_handlers } = actionContent ? actionContent : {}
  const { handleStopFetch } = action_handlers ? action_handlers : {}

  // appUserManagerContext
  const appUserManagerContext = useContext(AppUserManagerContext)
  const { appUserManager_state, appUserManager_handlers } = appUserManagerContext ? appUserManagerContext : {}
  const { selectedAppUser } = appUserManager_state ?? {}

  const [authUid, setAuthUid] = useState()
  const [invalidUser, setInvalidUser] = useState()
  const [confirmation, setConfirmation] = useState()
  const [updating, setUpdating] = useState()

  const [authData, setAuthData] = useState()
  const { email } = authData ? authData : {}

  const cb_userAuth = (result) => {
    const { uid, customClaims } = result ?? {}
    if (uid) {
      const md = customClaims ? { ...result, ...customClaims } : result
      setAuthUid(uid)
      setAuthData(md)
    } else {
      setInvalidUser(true)
      // setAuthData({})
    }
    handleStopFetch && handleStopFetch()
  }

  const cb_getAuth = (result) => {
    console.log('result', result)
    const { uid } = result ?? {}
    if (uid) {
      cb_userAuth(result)
    } else {
      fn_cls.getAuthByPhoneNumber(selectedAppUser, cb_userAuth)
    }
  }

  useEffect(() => {
    console.log('fn_cls', fn_cls)
    fn_cls.getAuthByEmail(selectedAppUser, cb_getAuth, _authProjectName, true)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [selectedAppUser]);

  // confirmation
  useEffect(() => {
    if (confirmation) {
      const timer = setTimeout(() => {
        setConfirmation()
      }, confirmation.success === true ? 3000 : 5000);
      return () => {
        clearTimeout(timer)
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmation]);

  const handleSaveResponse = (response) => {
    const { data } = response ?? {}
    const { success, result } = data ?? {}
    const { error } = result ?? {}
    const { errorInfo } = error ?? {}
    const { message } = errorInfo ? errorInfo : {}
    setUpdating(false)
    setConfirmation({
      title: success ? 'Updated' : message,
      success
    });
  }

  const handleUpdateAuthData = (d) => setAuthData(d)

  const handleSaveAuth = () => {
    const _authData = { pathViews }
    Object.keys(authData).forEach(key => {
      switch (key) {
        case 'newPassword':
        case 'confirmNewPassword':
          break;
        case 'authLevel':
        case 'disabled':
        case 'displayName':
        case 'email':
        case 'phoneNumber':
        case 'profileLevel':
          if (authData[key]) {
            _authData[key] = authData[key]
          }
          break;

        case 'clientAuthLevel':
          if (authData[key]) {
            _authData[key] = authData[key]
          } else {
            delete _authData[key]
          }
          break;
        default:
      }
    })
    if (authData.newPassword) {
      if (authData.newPassword === authData.confirmNewPassword) {
        _authData.password = authData.newPassword
      }
    }
    console.log('_authData', _authData)
    setUpdating(true)
    fn_cls.updateAuthByUid(authUid, _authData, handleSaveResponse, _authProjectName)
  }

  const handleDeleteAuth = () => {
    setUpdating(true)
    if (authUid) { fn_cls.deleteAuthByUid(authUid, null, handleSaveResponse) }
  }

  const appUserForm = () => <Wrapper
    content={<AppForm
      appFormType={pathViews && pathViews.clients ? appFormTypes.appAuth : appFormTypes.auth}
      data_parent={authData}
      handleUpdateParentData={handleUpdateAuthData}
      handleSave={handleSaveAuth}
      handleDelete={handleDeleteAuth}
      updating={updating}
    />}
    wrapperType={wrapperTypes.padded}
  ></Wrapper>

  const authContent = () => {
    if (invalidUser) {
      return <NoData fullCaption={'This user has not been authenticated.'} />
    } else {
      return authData ? appUserForm() : <MotionWait origin={'UserAuth'} />
    }
  }

  const fpw = () => <FullPageWrapper
    topperCaption={'Authorization'}
    topperCaption2={email}
    content={authContent()}
    handleCancel={handleCancel || appUserManager_handlers?.handleCancel} s
    css={{ container: 'app-dark-mode' }}>
  </FullPageWrapper>

  return fpw()

}

export default UserAuth